export default "__VITE_ASSET__Ckyy3eFD__"